// @ts-nocheck

import EmptyIntro from './empty-intro.vue'
import ChartV3Intro from './chart-v3-intro.vue'
import ChartV4Intro from './chart-v4-intro.vue'
import ChartV5Intro from './chart-v5-intro.vue'
import ChartV6Intro from './chart-v6-intro.vue'
import ChartV7Intro from './chart-v7-intro.vue'
import ChartV8Intro from './chart-v8-intro.vue'
import ChartV9Intro from './chart-v9-intro.vue'

export default {
  'empty-intro': EmptyIntro,
  'chart-v3-intro': ChartV3Intro,
  'chart-v4-intro': ChartV4Intro,
  'chart-v5-intro': ChartV5Intro,
  'chart-v6-intro': ChartV6Intro,
  'chart-v7-intro': ChartV7Intro,
  'chart-v8-intro': ChartV8Intro,
  'chart-v9-intro': ChartV9Intro,
}
